import { useRef, useEffect, useState } from 'react';
import { Transition, TransitionChild } from '@headlessui/react';

function ModalWrapper({
  // eslint-disable-next-line react/prop-types
  children, onClose, afterRender, delay,
}) {
  const contentRef = useRef();
  const [show, setShow] = useState(!delay);

  useEffect(() => {
    function handleClickOutside(event) {
      if (contentRef?.current && !contentRef.current.contains(event.target)) {
        if (onClose) onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    if (afterRender) {
      afterRender();
    }
  }, [afterRender]);

  useEffect(() => {
    let timer;
    if (delay) {
      if (!show) {
        timer = setTimeout(() => setShow(true), delay);
      }
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [show]);

  return (
    <Transition 
      show={show}
      as="div"
      enter="transition ease-out duration-200"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-in duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 overflow-y-auto z-60">
        <div className="flex items-start justify-start p-0 text-left modal sm:block sm:p-0">
          <div className="inset-0 lg:fixed" aria-hidden="true">
            <TransitionChild
              as="div"
              enter="transition-opacity ease-out duration-200"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-in duration-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
              className="absolute inset-0 bg-purple-5/80 backdrop-blur-sm"
            />
          </div>
          <TransitionChild
            as="div"
            enter="transition-all ease-out duration-200"
            enterFrom="opacity-0 scale-95 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 scale-100 translate-y-0 sm:scale-100"
            leave="transition-all ease-in duration-150"
            leaveFrom="opacity-100 scale-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 scale-95 translate-y-4 sm:translate-y-0 sm:scale-95"
            className="relative inline-block w-full transition-all transform shadow-2xl"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
            ref={contentRef}
          >
            <button
              onClick={onClose}
              className="absolute z-10 text-purple-0 top-4 right-4 hover:text-white focus:outline-none"
              aria-label="Fermer"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <div className="w-full">
              {children}
            </div>
          </TransitionChild>
        </div>
      </div>
    </Transition>
  );
}

export default ModalWrapper;
